import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { wtflogo } from "../../exports/Images";
import Loader from "../../components/ui/Loader";

const CommonLoginPage = ({
  errors,
  userInfo,
  setUserInfo,
  onClickFetchDetails,

  modValues,
  setModValues,
  onClickSubmit,
  onClickResend,
  onClickChangeNumber,
}) => {
  const { loading } = useSelector((state) => state.api);
  const { otp } = modValues || {};

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `00:${String(mins).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  const RenderLoginFields = () => (
    <div className="login_field">
      <label
        style={{
          textTransform: "capitalize",
          marginBottom: "5px",
        }}>
        Mobile Number ({userInfo.mobile?.length}/10)
      </label>
      <input
        id="number"
        type="number"
        placeholder="Enter 10 Digit Mobile Number"
        value={userInfo.mobile}
        onChange={(e) => {
          const mobileValue = e.target.value;

          if (mobileValue.length <= 10) {
            setUserInfo({
              ...userInfo,
              mobile: mobileValue,
            });
          }
        }}
        className="input-k"
      />
      {errors.userMobile && (
        <span className="error-message">{errors.userMobile}</span>
      )}
    </div>
  );

  const RenderOTPFields = () => (
    <div className="login_field">
      <label
        style={{
          textTransform: "capitalize",
          marginBottom: "5px",
        }}>
        OTP ({otp?.length}/7)
      </label>
      <input
        type="number"
        placeholder="Enter 7 Digit OTP"
        className={`formInput`}
        name="otp"
        value={otp}
        onChange={(e) => {
          const otpValue = e.target.value;

          if (otpValue.length <= 7) {
            setModValues((prevs) => ({
              ...prevs,
              otp: otpValue,
            }));
          }
        }}
      />
      {errors.otp && <span className="error-message">{errors.otp}</span>}
      {modValues.timerCount && (
        <span className="error-message">
          Resend OTP in <b>{formatTime(modValues.timerCount)}</b>
        </span>
      )}
    </div>
  );

  return (
    <div className="login login-open-access">
      <div className="page-label-container">
        <h1 className="page-label">
          WTF Trainer/Sales Executive/Club Manager Login
        </h1>
      </div>

      <form className="login__Wrapper">
        <div className="login_Card">
          <img src={wtflogo} alt="wtf-logo" />

          <div className="login__fields">
            {modValues.isModOpen ? RenderOTPFields() : RenderLoginFields()}
          </div>

          {modValues.isModOpen ? (
            <div
              className="btn-container"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                rowGap: "1rem",
              }}>
              {otp?.length === 7 && (
                <button
                  className="login__buttonRed"
                  type="button"
                  onClick={(e) => onClickSubmit(e)}
                  style={{
                    textTransform: "capitalize",
                    cursor: "pointer",
                    letterSpacing: "1px",
                  }}>
                  Submit
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-box-arrow-in-right"
                    viewBox="0 0 16 16"
                    style={{
                      width: "20px",
                      height: "20px",
                      fill: "#fff",
                      marginLeft: "5px",
                    }}>
                    <path
                      fillRule="evenodd"
                      d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
                    />
                    <path
                      fillRule="evenodd"
                      d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                    />
                  </svg>
                </button>
              )}

              {!modValues.timerCount && (
                <button
                  className="login__buttonRed"
                  type="button"
                  onClick={(e) => onClickResend(e)}
                  style={{
                    textTransform: "capitalize",
                    cursor: "pointer",
                    letterSpacing: "1px",
                  }}>
                  resend
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-clockwise"
                    viewBox="0 0 16 16"
                    style={{
                      width: "20px",
                      height: "20px",
                      fill: "#fff",
                      marginLeft: "5px",
                    }}>
                    <path
                      fillRule="evenodd"
                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                    />
                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                  </svg>
                </button>
              )}

              {modValues.isModOpen && (
                <button
                  className="login__buttonRed"
                  type="button"
                  onClick={(e) => onClickChangeNumber(e)}
                  style={{
                    textTransform: "capitalize",
                    cursor: "pointer",
                    letterSpacing: "1px",
                  }}>
                  change number
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-right-short"
                    viewBox="0 0 16 16"
                    style={{
                      width: "20px",
                      height: "20px",
                      fill: "#fff",
                      marginLeft: "5px",
                    }}>
                    <path
                      fillRule="evenodd"
                      d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
                    />
                  </svg>
                </button>
              )}
            </div>
          ) : (
            <>
              {loading ? (
                <Loader />
              ) : (
                <button
                  disabled={loading}
                  className="login__buttonRed"
                  type="button"
                  onClick={(e) => onClickFetchDetails(e)}
                  style={{
                    textTransform: "capitalize",
                    cursor: "pointer",
                    letterSpacing: "1px",
                  }}>
                  login
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-box-arrow-in-right"
                    viewBox="0 0 16 16"
                    style={{
                      width: "20px",
                      height: "20px",
                      fill: "#fff",
                      marginLeft: "5px",
                    }}>
                    <path
                      fillRule="evenodd"
                      d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0z"
                    />
                    <path
                      fillRule="evenodd"
                      d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
                    />
                  </svg>
                </button>
              )}
              <Link to="/" className="bottom__PageLink">
                Login to dashboard
              </Link>
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default CommonLoginPage;
